import { EdgeListEquipmentItemOptionsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListEquipmentItemOptions } from '@/shared/domain/use-cases'

export function makeListEquipmentItemOptions(): ListEquipmentItemOptions {
  return new EdgeListEquipmentItemOptionsRepository(makeSupabaseEdgeHttpClient()).execute
}
